import { Injectable } from "@angular/core";
import timezones from "timezones-list";

@Injectable()
export class TimeZoneService {
    public static getTimeZones(): { [key: string]: string } {
        const result: { [key: string]: string } = {};

        timezones.forEach(({ tzCode, name }) => {
            // Extract the GMT offset from name
            const gmtMatch = name.match(/\(GMT[+-]\d{2}:\d{2}\)/);
            const gmtPrefix = gmtMatch ? gmtMatch[0] : "";

            // Extract a concise name (e.g., first city after the GMT offset)
            const nameWithoutPrefix = name.replace(gmtPrefix, "").trim();

            const shortName = nameWithoutPrefix.split(",")[0].trim();

            // Special-case logic: insert tz region name in parentheses if needed
            const region = tzCode.split("/")[1] || "";
            const formattedRegion = region.replace(/_/g, " ");
            const displayName = shortName.includes(formattedRegion)
                ? shortName
                : `${formattedRegion} (${shortName})`;

            result[tzCode] = `${gmtPrefix} ${displayName}`;
        });

        return result;
    }

}
